export var OBJECT_SUBSCHEMA_SYMBOL = Symbol('initialSubschema');
export var FIELD_SUBSCHEMA_MAP_SYMBOL = Symbol('subschemaMap');
//# sourceMappingURL=symbols.js.map